import React from "react";

export const WhyWatcho = () => {
  return (
    <div className="Howorks">
      <h2 className="heading-bogy  ">Why vzy?</h2>
      <div className="features-grid">
        <div className="feature-item">
          <img src="/Images/image 38.png" alt="Unbeatable Prices Icon" />
          <h6>Unbeatable Prices</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 39.png" alt="Variety of Content Icon" />
          <h6>Variety of Content</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 40.png" alt="Watch At Convenience Icon" />
          <h6>Watch At Convenience</h6>
        </div>
        <div className="feature-item">
          <img
            src="/Images/image 41.png"
            alt="Multi-Device Compatibility Icon"
          />
          <h6>Multi-Device Compatibility</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 42.png" alt="No Commercials Icon" />
          <h6>No Commercials</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 43.png" alt="Offline Viewing Icon" />
          <h6>Offline Viewing</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 44.png" alt="Original Content Icon" />
          <h6>Original Content</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 45.png" alt="Parental Controls Icon" />
          <h6>Parental Controls</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 46.png" alt="Continuous Updates Icon" />
          <h6>Continuous Updates</h6>
        </div>
        <div className="feature-item">
          <img src="/Images/image 47.png" alt="Access Anywhere Icon" />
          <h6>Access Anywhere</h6>
        </div>
      </div>
    </div>
  );
};
